"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_LIMIT_PER_SECTION = void 0;
exports.WIDGET_LIMIT_PER_SECTION = 20;
